import React from 'react'
import AboutUs from '../about-us'

const AboutUsNo = () => {
    return <AboutUs languageCode="no" />
}

export default AboutUsNo
